import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-military-calisthenics': {
			// Figma "Option B" (4-week calendar/progress graphic)
			// ?safe&exp=web_military_calisthenics_loader_teaser~1 on /military-calisthenics-m
			landing: {
				experiment: () =>
					import('@/modules/Landing/instances/experiments/web_military_calisthenics_loader_teaser/__b_m'),
			},
		},
		'activity-female-military-calisthenics': {
			// Figma "Option B" (4-week calendar/progress graphic)
			// ?safe&exp=web_military_calisthenics_loader_teaser~1 on /military-calisthenics-f
			landing: {
				experiment: () =>
					import('@/modules/Landing/instances/experiments/web_military_calisthenics_loader_teaser/__b_f'),
			},
		},
	},
	{
		'activity-male-military-calisthenics': {
			// Figma "Option C" ("NOW OR NEVER." dark headline + subtitle)
			// ?safe&exp=web_military_calisthenics_loader_teaser~2 on /military-calisthenics-m
			landing: {
				experiment: () =>
					import('@/modules/Landing/instances/experiments/web_military_calisthenics_loader_teaser/__c_m'),
			},
		},
		'activity-female-military-calisthenics': {
			// Figma "Option C" ("NOW OR NEVER." dark headline + subtitle)
			// ?safe&exp=web_military_calisthenics_loader_teaser~2 on /military-calisthenics-f
			landing: {
				experiment: () =>
					import('@/modules/Landing/instances/experiments/web_military_calisthenics_loader_teaser/__c_f'),
			},
		},
	},
]

export default config
